import { useEffect, useState } from 'react';
import CourseDetailsApi from '../Api/CourseDetailsApi';

/**
 * ? Información de retorno del hook.
 * @typedef {Object} CourseData
 * @property {import('Api/Request/Course/findOneCourse').CourseData} course Información del curso.
 * @property {boolean} loading Estado de carga.
 */

/**
 * ? Hook para pantalla del detalle de un curso, obtiene toda la información del curso necesaria.
 * @param {Object} params Parámetros de configuración.
 * @param {string} params.courseId ID del curso a consultar.
 * @returns {CourseData} Información del curso y estado de carga.
 */
const useCourseDetailsApi = ({ courseId } = {}) => {
  // Información del curso especifico.
  const [course, setCourse] = useState();
  // Muestra un cargando si la información aún no ha sido cargada.
  const [loading, setLoading] = useState(false);

  // Función para leer la información de un curso específico.
  const readCourseInformation = async () => {
    setLoading(true);
    // LLamada a la API para obtener la información del curso.
    CourseDetailsApi.readOne(courseId).then(response => {
      setCourse(response?.findOneCourse);
      setLoading(false);
    });
  };

  useEffect(() => {
    // Si no se proporciona el "courseId" se leen todos.

    if (!courseId) {
      return;
    }
    // Se lee la información del curso.
    readCourseInformation();
  }, []);

  return {
    course,
    loading,
  };
};

export default useCourseDetailsApi;
